import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import style from "../../OrderInfoAviation.module.scss";
import LightningBoldIcon from "../../../../shared/icons/LightningBoldIcon";
import BoxIcon from "../../../../shared/icons/BoxIcon";
import ContractIcon from "../../../../shared/icons/ContractIcon";

const TABS = [
  { key: "actions", labelKey: "actions", Icon: LightningBoldIcon, iconSize: 16 },
  { key: "cargo", labelKey: "cargo", Icon: BoxIcon, iconSize: 18 },
  { key: "documents", labelKey: "documents", Icon: ContractIcon, iconSize: 18 },
];

const OrderInfoAviationTabs = ({ activeTab, onTabChange, documentsCount = 0 }) => {
  const { t } = useTranslation();

  return (
    <div className={style.tabs}>
      <div className={style.tabs_list} role="tablist">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;

          return (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={cn(style.tabs_item, { [style.tabs_item_active]: isActive })}
              onClick={() => onTabChange(tab.key)}
            >
              <tab.Icon
                width={tab.iconSize}
                height={tab.iconSize}
                fill={isActive ? "#0D3B66" : "#6D7885"}
                color={isActive ? "#0D3B66" : "#6D7885"}
                type={1}
              />
              <span>{t(`orderInfoAviation.tabs.${tab.labelKey}`)}</span>
              {tab.key === "documents" && documentsCount > 0 ? (
                <span className={style.tabs_badge}>{documentsCount}</span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OrderInfoAviationTabs;
